import { useContentCache, useOptionsStore, useUserStore } from "@/entities"
import { userControllerDeleteMe } from "@/shared/api/generated"
import { useMutation } from "@tanstack/react-query"
import { useState } from "react"

export function useAccountDelete() {
  const [isLoading, setLoading] = useState(false)

  const logout = useUserStore(s => s.logout)
  const resetOptions = useOptionsStore(s => s.reset)
  const contentCache = useContentCache()
  const formMutation = useMutation({
    mutationFn: userControllerDeleteMe,
    async onSuccess() {
      logout()
      contentCache.clear()
      resetOptions()
      setLoading(false)
    },
  })

  return {
    handleSubmit: () => {
      setLoading(true)
      formMutation.mutate({})
    },
    isLoading,
  }
}
